import React from "react";
import { ManageAffiliationsContent } from "../components/MasterSettings/AffiliationsMaster/ManageAffiliationsContent";
import { ToastContainer } from "react-toastify";

export const AffiliationsMaster = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <ManageAffiliationsContent />
        </div>
      </div>
    </div>
  );
};
